import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Root ('') redirect.
 *
 * The root used to redirect unconditionally to /login, so a user who was
 * already signed in was thrown back to the login screen every time the app was
 * cold-started — even though their token was still in localStorage.
 *
 * Now: token present -> straight to the app; no token -> login.
 */
export const authRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = localStorage.getItem('authToken');

  // NOTE: the old, unused homeGuard did JSON.parse(authToken). The token is a
  // JWT *string*, not JSON, so that always threw and bounced to /login. Just
  // check that a non-empty token exists.
  const signedIn = !!token && token !== 'null' && token !== 'undefined';

  router.navigate([signedIn ? '/tabs/home' : '/login'], { replaceUrl: true });
  return false;
};
